<template>
    <div>
        <ProfileLevelInfo v-if="isLoginAccount"></ProfileLevelInfo>
        <ConnectSocial v-if="isLoginAccount"></ConnectSocial>
        <AccountInfo v-if="isLoginAccount"></AccountInfo>
        <AppInfo></AppInfo>
        <div v-if="isLoginAccount" class="flex justify-center items-center mt-9 mb-9">
            <img class="h-25px cursor-pointer" src="../../../../assets/profile_icon/logoutsvg.svg" @click="clickLogout()">
            <div class="text-16 text-a-brown-502314 pl-2 cursor-pointer" @click="clickLogout()">{{lbl.profile.sign_out}}</div>
        </div>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import FBFunction from '@/helper/facade/FBFunction';
//component
import ProfileLevelInfo from './component/ProfileLevelInfo.vue'
import ConnectSocial from './component/ConnectSocial.vue';
import AccountInfo from './component/AccountInfo.vue';
import AppInfo from './component/AppInfo.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import DeliveryMixin from '@/mixin/DeliveryMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    mixins: [ModalMixin, AuthStatusMixin,DeliveryMixin,LocaleMixin],
    inject: ['PlaceOrderStore'],
    components: {
        ProfileLevelInfo,
        ConnectSocial,
        AccountInfo,
        AppInfo,
    },
    methods: {
        clickLogout: function () {
            this.modal.confirmModal
                .clearModal()
                .setMsg(this.lbl.profile.popup_logout.msg)
                .setBtnOk(this.lbl.profile.popup_logout.confirm)
                .show();
            this.modal.confirmModal.onClickOk(() => {
                this.tracking.event('moremenu','click_confirm_to_signout');
                this.logout();
            });
        },

        logout: async function () {
            if (Account.isLoginWithFacebook()) {
                await this.logoutFacebook();
            }

            this.logoutBzbs();
        },

        logoutFacebook: function () {
            return new Promise((resolve) => {
                let fb = new FBFunction();
                fb.logout().then(() => {
                    resolve();
                }).catch(() => {
                    resolve();
                });
            });
        },
        logoutBzbs: function () {
            Account.setLogout().then(() => {
                this.PlaceOrderStore.methods.removePlaceOrder();
                window.location.replace('/home');
            }).catch(() => {
                this.PlaceOrderStore.methods.removePlaceOrder();
                window.location.replace('/home');
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
